/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * OSI.Core
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApiResponse,
  ApiResponseResponsesAuthorizeResponseOSICoreTypes,
  ApiResponseResponsesUserContactResponseOSICoreTypes,
  ApiResponseStringSystemPrivateCoreLib,
  PostApiAuthLdapParams,
  PostApiAuthParams
} from '../models';

import { axiosForReactQueryInstance } from '../../reactQuery';
import type { ErrorType } from '../../reactQuery';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Авторизация пользователя для фронта, скрытая в сваггере
 */
export const postApiAuth = (
  params?: PostApiAuthParams,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseResponsesAuthorizeResponseOSICoreTypes>(
    { url: `/api/Auth`, method: 'POST', params, signal },
    options
  );
};

export const getPostApiAuthMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAuth>>,
    TError,
    { params?: PostApiAuthParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof postApiAuth>>, TError, { params?: PostApiAuthParams }, TContext> => {
  const mutationKey = ['postApiAuth'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAuth>>, { params?: PostApiAuthParams }> = (
    props
  ) => {
    const { params } = props ?? {};

    return postApiAuth(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiAuthMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAuth>>>;

export type PostApiAuthMutationError = ErrorType<unknown>;

/**
 * @summary Авторизация пользователя для фронта, скрытая в сваггере
 */
export const usePostApiAuth = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiAuth>>,
      TError,
      { params?: PostApiAuthParams },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof postApiAuth>>, TError, { params?: PostApiAuthParams }, TContext> => {
  const mutationOptions = getPostApiAuthMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Авторизация пользователя через LDAP, доступная в сваггере
 */
export const postApiAuthLdap = (
  params?: PostApiAuthLdapParams,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseResponsesAuthorizeResponseOSICoreTypes>(
    { url: `/api/Auth/ldap`, method: 'POST', params, signal },
    options
  );
};

export const getPostApiAuthLdapMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAuthLdap>>,
    TError,
    { params?: PostApiAuthLdapParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiAuthLdap>>,
  TError,
  { params?: PostApiAuthLdapParams },
  TContext
> => {
  const mutationKey = ['postApiAuthLdap'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiAuthLdap>>,
    { params?: PostApiAuthLdapParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiAuthLdap(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiAuthLdapMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAuthLdap>>>;

export type PostApiAuthLdapMutationError = ErrorType<unknown>;

/**
 * @summary Авторизация пользователя через LDAP, доступная в сваггере
 */
export const usePostApiAuthLdap = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiAuthLdap>>,
      TError,
      { params?: PostApiAuthLdapParams },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiAuthLdap>>,
  TError,
  { params?: PostApiAuthLdapParams },
  TContext
> => {
  const mutationOptions = getPostApiAuthLdapMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Обновление токена пользователя
 */
export const postApiAuthRefresh = (
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseStringSystemPrivateCoreLib>(
    { url: `/api/Auth/refresh`, method: 'POST', signal },
    options
  );
};

export const getPostApiAuthRefreshMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postApiAuthRefresh>>, TError, void, TContext>;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof postApiAuthRefresh>>, TError, void, TContext> => {
  const mutationKey = ['postApiAuthRefresh'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAuthRefresh>>, void> = () => {
    return postApiAuthRefresh(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiAuthRefreshMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAuthRefresh>>>;

export type PostApiAuthRefreshMutationError = ErrorType<unknown>;

/**
 * @summary Обновление токена пользователя
 */
export const usePostApiAuthRefresh = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof postApiAuthRefresh>>, TError, void, TContext>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof postApiAuthRefresh>>, TError, void, TContext> => {
  const mutationOptions = getPostApiAuthRefreshMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Проверить контактные данные
 */
export const getApiAuthCheckContactPhone = (
  phone: string,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseResponsesUserContactResponseOSICoreTypes>(
    { url: `/api/Auth/check-contact/${phone}`, method: 'GET', signal },
    options
  );
};

export const getGetApiAuthCheckContactPhoneQueryKey = (phone: string) => {
  return [`/api/Auth/check-contact/${phone}`] as const;
};

export const getGetApiAuthCheckContactPhoneQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAuthCheckContactPhone>>,
  TError = ErrorType<unknown>
>(
  phone: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthCheckContactPhone>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiAuthCheckContactPhoneQueryKey(phone);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAuthCheckContactPhone>>> = ({ signal }) =>
    getApiAuthCheckContactPhone(phone, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!phone, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAuthCheckContactPhone>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAuthCheckContactPhoneQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAuthCheckContactPhone>>
>;
export type GetApiAuthCheckContactPhoneQueryError = ErrorType<unknown>;

export function useGetApiAuthCheckContactPhone<
  TData = Awaited<ReturnType<typeof getApiAuthCheckContactPhone>>,
  TError = ErrorType<unknown>
>(
  phone: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthCheckContactPhone>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAuthCheckContactPhone>>,
          TError,
          Awaited<ReturnType<typeof getApiAuthCheckContactPhone>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAuthCheckContactPhone<
  TData = Awaited<ReturnType<typeof getApiAuthCheckContactPhone>>,
  TError = ErrorType<unknown>
>(
  phone: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthCheckContactPhone>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAuthCheckContactPhone>>,
          TError,
          Awaited<ReturnType<typeof getApiAuthCheckContactPhone>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAuthCheckContactPhone<
  TData = Awaited<ReturnType<typeof getApiAuthCheckContactPhone>>,
  TError = ErrorType<unknown>
>(
  phone: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthCheckContactPhone>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Проверить контактные данные
 */

export function useGetApiAuthCheckContactPhone<
  TData = Awaited<ReturnType<typeof getApiAuthCheckContactPhone>>,
  TError = ErrorType<unknown>
>(
  phone: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthCheckContactPhone>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiAuthCheckContactPhoneQueryOptions(phone, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Генерация 6-тизначного кода (ОТП) по данному номеру
 */
export const getApiAuthGetOtpPhone = (
  phone: string,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseStringSystemPrivateCoreLib>(
    { url: `/api/Auth/get-otp/${phone}`, method: 'GET', signal },
    options
  );
};

export const getGetApiAuthGetOtpPhoneQueryKey = (phone: string) => {
  return [`/api/Auth/get-otp/${phone}`] as const;
};

export const getGetApiAuthGetOtpPhoneQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAuthGetOtpPhone>>,
  TError = ErrorType<unknown>
>(
  phone: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthGetOtpPhone>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiAuthGetOtpPhoneQueryKey(phone);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAuthGetOtpPhone>>> = ({ signal }) =>
    getApiAuthGetOtpPhone(phone, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!phone, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAuthGetOtpPhone>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAuthGetOtpPhoneQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAuthGetOtpPhone>>>;
export type GetApiAuthGetOtpPhoneQueryError = ErrorType<unknown>;

export function useGetApiAuthGetOtpPhone<
  TData = Awaited<ReturnType<typeof getApiAuthGetOtpPhone>>,
  TError = ErrorType<unknown>
>(
  phone: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthGetOtpPhone>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAuthGetOtpPhone>>,
          TError,
          Awaited<ReturnType<typeof getApiAuthGetOtpPhone>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAuthGetOtpPhone<
  TData = Awaited<ReturnType<typeof getApiAuthGetOtpPhone>>,
  TError = ErrorType<unknown>
>(
  phone: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthGetOtpPhone>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAuthGetOtpPhone>>,
          TError,
          Awaited<ReturnType<typeof getApiAuthGetOtpPhone>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAuthGetOtpPhone<
  TData = Awaited<ReturnType<typeof getApiAuthGetOtpPhone>>,
  TError = ErrorType<unknown>
>(
  phone: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthGetOtpPhone>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Генерация 6-тизначного кода (ОТП) по данному номеру
 */

export function useGetApiAuthGetOtpPhone<
  TData = Awaited<ReturnType<typeof getApiAuthGetOtpPhone>>,
  TError = ErrorType<unknown>
>(
  phone: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthGetOtpPhone>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiAuthGetOtpPhoneQueryOptions(phone, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Генерация 6-тизначного кода (ОТП) и отправка в телеграм/sms по данному номеру
 */
export const getApiAuthGenerateOtpPhone = (
  phone: string,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    { url: `/api/Auth/generate-otp/${phone}`, method: 'GET', signal },
    options
  );
};

export const getGetApiAuthGenerateOtpPhoneQueryKey = (phone: string) => {
  return [`/api/Auth/generate-otp/${phone}`] as const;
};

export const getGetApiAuthGenerateOtpPhoneQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAuthGenerateOtpPhone>>,
  TError = ErrorType<unknown>
>(
  phone: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthGenerateOtpPhone>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiAuthGenerateOtpPhoneQueryKey(phone);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAuthGenerateOtpPhone>>> = ({ signal }) =>
    getApiAuthGenerateOtpPhone(phone, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!phone, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAuthGenerateOtpPhone>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAuthGenerateOtpPhoneQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAuthGenerateOtpPhone>>>;
export type GetApiAuthGenerateOtpPhoneQueryError = ErrorType<unknown>;

export function useGetApiAuthGenerateOtpPhone<
  TData = Awaited<ReturnType<typeof getApiAuthGenerateOtpPhone>>,
  TError = ErrorType<unknown>
>(
  phone: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthGenerateOtpPhone>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAuthGenerateOtpPhone>>,
          TError,
          Awaited<ReturnType<typeof getApiAuthGenerateOtpPhone>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAuthGenerateOtpPhone<
  TData = Awaited<ReturnType<typeof getApiAuthGenerateOtpPhone>>,
  TError = ErrorType<unknown>
>(
  phone: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthGenerateOtpPhone>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAuthGenerateOtpPhone>>,
          TError,
          Awaited<ReturnType<typeof getApiAuthGenerateOtpPhone>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAuthGenerateOtpPhone<
  TData = Awaited<ReturnType<typeof getApiAuthGenerateOtpPhone>>,
  TError = ErrorType<unknown>
>(
  phone: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthGenerateOtpPhone>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Генерация 6-тизначного кода (ОТП) и отправка в телеграм/sms по данному номеру
 */

export function useGetApiAuthGenerateOtpPhone<
  TData = Awaited<ReturnType<typeof getApiAuthGenerateOtpPhone>>,
  TError = ErrorType<unknown>
>(
  phone: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthGenerateOtpPhone>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiAuthGenerateOtpPhoneQueryOptions(phone, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Проверка 6-тизначного кода (ОТП)
 */
export const getApiAuthVerifyOtpPhoneOtp = (
  phone: string,
  otp: string,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseResponsesAuthorizeResponseOSICoreTypes>(
    { url: `/api/Auth/verify-otp/${phone}/${otp}`, method: 'GET', signal },
    options
  );
};

export const getGetApiAuthVerifyOtpPhoneOtpQueryKey = (phone: string, otp: string) => {
  return [`/api/Auth/verify-otp/${phone}/${otp}`] as const;
};

export const getGetApiAuthVerifyOtpPhoneOtpQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAuthVerifyOtpPhoneOtp>>,
  TError = ErrorType<unknown>
>(
  phone: string,
  otp: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthVerifyOtpPhoneOtp>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiAuthVerifyOtpPhoneOtpQueryKey(phone, otp);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAuthVerifyOtpPhoneOtp>>> = ({ signal }) =>
    getApiAuthVerifyOtpPhoneOtp(phone, otp, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(phone && otp), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAuthVerifyOtpPhoneOtp>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAuthVerifyOtpPhoneOtpQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAuthVerifyOtpPhoneOtp>>
>;
export type GetApiAuthVerifyOtpPhoneOtpQueryError = ErrorType<unknown>;

export function useGetApiAuthVerifyOtpPhoneOtp<
  TData = Awaited<ReturnType<typeof getApiAuthVerifyOtpPhoneOtp>>,
  TError = ErrorType<unknown>
>(
  phone: string,
  otp: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthVerifyOtpPhoneOtp>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAuthVerifyOtpPhoneOtp>>,
          TError,
          Awaited<ReturnType<typeof getApiAuthVerifyOtpPhoneOtp>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAuthVerifyOtpPhoneOtp<
  TData = Awaited<ReturnType<typeof getApiAuthVerifyOtpPhoneOtp>>,
  TError = ErrorType<unknown>
>(
  phone: string,
  otp: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthVerifyOtpPhoneOtp>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAuthVerifyOtpPhoneOtp>>,
          TError,
          Awaited<ReturnType<typeof getApiAuthVerifyOtpPhoneOtp>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAuthVerifyOtpPhoneOtp<
  TData = Awaited<ReturnType<typeof getApiAuthVerifyOtpPhoneOtp>>,
  TError = ErrorType<unknown>
>(
  phone: string,
  otp: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthVerifyOtpPhoneOtp>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Проверка 6-тизначного кода (ОТП)
 */

export function useGetApiAuthVerifyOtpPhoneOtp<
  TData = Awaited<ReturnType<typeof getApiAuthVerifyOtpPhoneOtp>>,
  TError = ErrorType<unknown>
>(
  phone: string,
  otp: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthVerifyOtpPhoneOtp>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiAuthVerifyOtpPhoneOtpQueryOptions(phone, otp, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Удалить контакт из бота
 */
export const getApiAuthClearContactPhone = (
  phone: string,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    { url: `/api/Auth/clear-contact/${phone}`, method: 'GET', signal },
    options
  );
};

export const getGetApiAuthClearContactPhoneQueryKey = (phone: string) => {
  return [`/api/Auth/clear-contact/${phone}`] as const;
};

export const getGetApiAuthClearContactPhoneQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiAuthClearContactPhone>>,
  TError = ErrorType<unknown>
>(
  phone: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthClearContactPhone>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiAuthClearContactPhoneQueryKey(phone);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAuthClearContactPhone>>> = ({ signal }) =>
    getApiAuthClearContactPhone(phone, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!phone, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiAuthClearContactPhone>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiAuthClearContactPhoneQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiAuthClearContactPhone>>
>;
export type GetApiAuthClearContactPhoneQueryError = ErrorType<unknown>;

export function useGetApiAuthClearContactPhone<
  TData = Awaited<ReturnType<typeof getApiAuthClearContactPhone>>,
  TError = ErrorType<unknown>
>(
  phone: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthClearContactPhone>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAuthClearContactPhone>>,
          TError,
          Awaited<ReturnType<typeof getApiAuthClearContactPhone>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAuthClearContactPhone<
  TData = Awaited<ReturnType<typeof getApiAuthClearContactPhone>>,
  TError = ErrorType<unknown>
>(
  phone: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthClearContactPhone>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAuthClearContactPhone>>,
          TError,
          Awaited<ReturnType<typeof getApiAuthClearContactPhone>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiAuthClearContactPhone<
  TData = Awaited<ReturnType<typeof getApiAuthClearContactPhone>>,
  TError = ErrorType<unknown>
>(
  phone: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthClearContactPhone>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Удалить контакт из бота
 */

export function useGetApiAuthClearContactPhone<
  TData = Awaited<ReturnType<typeof getApiAuthClearContactPhone>>,
  TError = ErrorType<unknown>
>(
  phone: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAuthClearContactPhone>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiAuthClearContactPhoneQueryOptions(phone, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
